<app-base-side-panel-modal>
  <ng-template #header>
    <div class="flex justify-start items-center gap-3">
      <svg-icon class="w-8 h-8 svg-dark" [src]="'edit'"></svg-icon>
      <div class="flex flex-col overflow-hidden">
        <div class="text-navy-90">
          {{ buildTranslationKey('policy.edit') | translate }}
        </div>

        <div class="text-navy-70 text-lg font-normal truncate">{{ policy.original_name }}</div>
      </div>
    </div>
  </ng-template>

  <ng-template #content>
    <div
      class="flex flex-col relative gap-5"
      [class.hide-is-public]="!evidence.evidence_id"
      [class.thin-show-text]="form?.controls['isVisible'].value === false"
    >
      <div class="policy-actions">
        <app-icon-button
          class="reset-btn"
          [type]="'basic'"
          [size]="'micro'"
          [verticalSize]="'micro'"
          [svgIconPath]="'refresh'"
          [iconSize]="'tiny'"
          [ngbTooltip]="buildTranslationKey('resetNameToDefault') | translate"
          [placement]="'top'"
          (click)="resetPolicyName()"
        ></app-icon-button>

        <app-icon-button
          class="navigate-btn"
          [type]="'basic'"
          [size]="'micro'"
          [verticalSize]="'micro'"
          [svgIconPath]="'newscreen'"
          [iconSize]="'tiny'"
          [ngbTooltip]="buildTranslationKey('viewPolicy') | translate"
          [placement]="'top'"
          (click)="navigateToPolicy()"
        ></app-icon-button>
      </div>

      <dynamic-form-outlet [dynamicFormGroup]="form"></dynamic-form-outlet>

      @if (shouldShowFileAccessWarning) {
        <app-tip [tipType]="tipTypes.NOTICE">
          {{ buildTranslationKey('fileAccessWarning') | translate }}
        </app-tip>
      }
    </div>
  </ng-template>

  <ng-template #footer>
    <div class="flex gap-2">
      <app-new-button
        class="checkmark-button"
        [saveButtonSizeDuringLoading]="true"
        [type]="'primary'"
        [svgIconPath]="'checkmark'"
        [size]="'responsive'"
        [loading]="sendingRequestBtnLoader$ | async"
        [disabled]="!isFormValid"
        (click)="saveBtnClick()"
      >
        {{ buildTranslationKey('saveChangesBtn') | translate }}
      </app-new-button>

      <app-new-button [size]="'responsive'" [type]="'secondary'" (click)="closePanel()">
        {{ buildTranslationKey('cancel') | translate }}
      </app-new-button>
    </div>
  </ng-template>
</app-base-side-panel-modal>

<ng-template #middleFormTmpl>
  <div class="flex flex-col gap-5">
    <div class="flex flex-col gap-2 text-navy-90 text-base">
      <div>
        <span class="font-bold">{{ buildTranslationKey('lastApprovedOn') | translate }}</span>
        {{ policy.approval_time | localDate: dateFormat }}
      </div>
      <div>
        <span class="font-bold">{{ buildTranslationKey('approvedBy') | translate }}</span>
        {{ policy.approved_by }}
      </div>
    </div>

    <app-evidence
      [allowDelete]="false"
      [readonly]="false"
      [evidenceId]="evidence.evidence_id"
      (openPreview)="modalOpened()"
    ></app-evidence>
  </div>
</ng-template>
